import { generatePath } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { NewDayTripPlanEditContainer } from "@/components/features/items/edit/plan/day-trip/default/ui/new";

import { useGetNewDayTripPlanEditPageParams } from "./_hooks/use-get-new-day-trip-plan-edit-page-params";

export const NewDayTripPlanEditPageDefault = () => {
	const { hotelID, duplicateItemID } = useGetNewDayTripPlanEditPageParams();
	const activeLangCode = LangCode.Default;

	return (
		<PageMeta
			title="日帰りプランの作成"
			url={generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.NEW.PLAN.DAYTRIP, { hotelID })}
		>
			<NewDayTripPlanEditContainer hotelID={hotelID} planID={duplicateItemID} activeLangCode={activeLangCode} />
		</PageMeta>
	);
};

NewDayTripPlanEditPageDefault.displayName = "NewDayTripPlanEditPageDefault";
